export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/as-appsumo-logo-light.f055f139.svg","height":23,"width":150};